import React, { forwardRef } from 'react';
import styles from './index.module.scss';
import classnames from 'classnames';

// ref 指向按鈕本體，供外層套用縮放等樣式（VocabularyExample 讓它與內容一起縮放）
const TranslationControlsButton = forwardRef(({ className, active, content, onClick }, ref) => (
  <div
    ref={ref}
    className={classnames(styles.button, className, {
      [styles.active]: active
    })}
    onClick={onClick}
  >
    <div>{content}</div>
    <div>{active ? '隱藏' : '顯示'}</div>
  </div>
));

export default TranslationControlsButton;
